import ContentLoader from "react-content-loader";
import { Color } from "../../enums/Color";

interface Props {
    styles?: any;
};

export const IntegrationLoader: React.FC<Props> = (props) => {
    const styles = props.styles;

    return (
        <div style={styles.loader}>
            <ContentLoader
                speed={1}
                backgroundColor={Color.LoaderBackground}
                foregroundColor={Color.LoaderForeground}
                width= {styles.width}
                height= {styles.height}
            >
                <>
                    <rect x="0" y="0" rx="3" ry="3" width="100%" height="100%" />
                </> 
            </ContentLoader> 
        </div>
    )
}